export default "__VITE_ASSET__DFYgFJ5b__"